import { defaultApiState } from '../api.state';

export const newsletterMutations = {
  GET_NEWSLETTERS_LOADING(state) {
    state.apiState.getNewsletters = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_NEWSLETTERS_SUCCESS(state, payload) {
    state.apiState.getNewsletters = {
      ...defaultApiState,
      success: true,
    };
    state.newsletters = payload;
  },
  GET_NEWSLETTERS_ERROR(state, error) {
    state.apiState.getNewsletters = {
      ...defaultApiState,
      error,
    };
  },

  ADD_NEWSLETTER_LOADING(state) {
    state.apiState.addNewsletter = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_NEWSLETTER_SUCCESS(state) {
    state.apiState.addNewsletter = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_NEWSLETTER_ERROR(state, error) {
    state.apiState.addNewsletter = {
      ...defaultApiState,
      error,
    };
  },

  GET_NEWSLETTER_RESET(state) {
    state.apiState.getNewsletter = {
      ...defaultApiState,
    };
    state.newsletter = undefined;
  },
  GET_NEWSLETTER_LOADING(state) {
    state.apiState.getNewsletter = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_NEWSLETTER_SUCCESS(state, payload) {
    state.apiState.getNewsletter = {
      ...defaultApiState,
      success: true,
    };
    state.newsletter = payload;
  },
  GET_NEWSLETTER_ERROR(state, error) {
    state.apiState.getNewsletter = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_NEWSLETTER_LOADING(state) {
    state.apiState.updateNewsletter = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_NEWSLETTER_SUCCESS(state) {
    state.apiState.updateNewsletter = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_NEWSLETTER_ERROR(state, error) {
    state.apiState.updateNewsletter = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_NEWSLETTER_LOADING(state) {
    state.apiState.deleteNewsletter = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_NEWSLETTER_SUCCESS(state, payload) {
    state.apiState.deleteNewsletter = {
      ...defaultApiState,
      success: true,
    };
    state.newsletters = state.newsletters.filter(o => o.id !== payload.id);
  },
  DELETE_NEWSLETTER_ERROR(state, error) {
    state.apiState.deleteNewsletter = {
      ...defaultApiState,
      error,
    };
  },
};
